import request from "@/utils/request";

// 实物促销跟进菜单 分页  代办处/经销商
export function pageByDTO(query) {
  return request({
    url: "/view/pageByDTO",
    method: "get",
    params: query,
  });
}

// 实物促销跟进菜单 集合  代办处/经销商
export function listByDTO(query) {
  return request({
    url: "/view/listByDTO",
    method: "get",
    params: query,
  });
}

// 实物促销跟进菜单 分页 CI  代办处/经销商
export function pageByDTOCI(query) {
  return request({
    url: "/view/pageByDTOCI",
    method: "get",
    params: query,
  });
}

// 实物促销跟进菜单 集合 CI  代办处/经销商
export function listByDTOCI(query) {
  return request({
    url: "/view/listByDTOCI",
    method: "get",
    params: query,
  });
}

// 南非3天2夜训练营促销 资格进度
export function zigeProgress(query) {
  return request({
    url: "procQualification/zigeProgress",
    method: "get",
    params: query,
  });
}
